import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8" }
const _hoisted_2 = { class: "max-w-max mx-auto" }
const _hoisted_3 = { class: "sm:flex" }
const _hoisted_4 = { class: "text-4xl font-extrabold text-indigo-600 sm:text-5xl" }
const _hoisted_5 = { class: "sm:ml-6" }
const _hoisted_6 = { class: "sm:border-l sm:border-gray-200 sm:pl-6" }
const _hoisted_7 = { class: "text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-base text-gray-500" }, " Please check the URL in the address bar and try again. ", -1)
const _hoisted_9 = { class: "mt-1 text-base text-gray-500" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" If the error persists, please reach out to ")
const _hoisted_11 = { class: "font-semibold" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.code), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1),
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.supportContactDetail), 1),
              _hoisted_12
            ])
          ])
        ])
      ])
    ])
  ]))
}